export default __webpack_public_path__ + "static/media/servicebottom.e8b51baa.jpg";